'use strict';

var getCurrentItem = require('../getCurrentItem');

/**
 * Split a list item at the start of the current range.
 *
 * @param  {Object} opts
 * @param  {Slate.Change} change
 * @return {Slate.Change}
 */
function splitListItem(opts, change) {
  var state = change.state;

  var currentItem = getCurrentItem(opts, state);
  var splitOffset = state.startOffset;

  return change.splitDescendantsByKey(currentItem.key, state.startKey, splitOffset);
}

module.exports = splitListItem;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-edit-list/dist/changes/splitListItem.js
// module id = 556
// module chunks = 0